/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAdditionalData200,
  GetApiV1PersonIdAdditionalData401,
  GetApiV1PersonIdAdditionalData404,
  GetApiV1PersonIdAdditionalData500,
  GetApiV1PersonIdAdditionalDataPathParams,
  GetApiV1PersonIdAdditionalDataQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdAdditionalData.ts";
import { personAdditionalDataViewModelSchema } from "../personAdditionalDataViewModelSchema.ts";

export const getApiV1PersonIdAdditionalDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdAdditionalDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAdditionalData200Schema = z.lazy(
  () => personAdditionalDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdAdditionalData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAdditionalData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAdditionalData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAdditionalData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAdditionalData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAdditionalData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAdditionalData500>;

export const getApiV1PersonIdAdditionalDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdAdditionalData200Schema,
) as unknown as ToZod<GetApiV1PersonIdAdditionalDataQueryResponse>;
